// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29yZ-","left":"styles_left__1VcNW","desktopActions":"styles_desktopActions___wmmi","title":"styles_title__3aTN1"};